import { Button, EmptyState, Skeleton } from "@nabble/ui";
import type { AccountSectionId } from "./accountSections";
import { AuthenticationSection } from "./authentication/AuthenticationSection";
import { DataSection } from "./data/DataSection";
import { ProfileSection } from "./profile/ProfileSection";
import { SessionsSection } from "./sessions/SessionsSection";
import { useAccount } from "./useAccount";

const LOADING_CARDS = [0, 1];

/** The view chosen in the left list. Every view but "Your data" works on the loaded account. */
export function AccountSectionBody({ section }: { section: AccountSectionId }): React.JSX.Element {
  const { account, loadError, reload } = useAccount();

  if (section === "data") return <DataSection />;
  if (loadError) {
    return (
      <div className="nb-card">
        <EmptyState
          icon="alertCircle"
          title="We couldn't load your account"
          description={loadError}
          action={<Button label="Try again" variant="secondary" icon="refresh" onClick={reload} />}
        />
      </div>
    );
  }
  if (!account) {
    return (
      <>
        {LOADING_CARDS.map((i) => (
          <div key={i} className="nb-card nb-card-pad nb-stack">
            <Skeleton width="25%" height={16} />
            <Skeleton width="55%" height={12} />
            <Skeleton height={40} radius={10} />
          </div>
        ))}
      </>
    );
  }
  if (section === "profile") return <ProfileSection account={account} onChanged={reload} />;
  if (section === "authentication") return <AuthenticationSection account={account} onChanged={reload} />;
  return <SessionsSection sessions={account.sessions} onChanged={reload} />;
}
